import {IIntegrationsState, initialIntegrationsState} from '@app/core/store/state/integrations.state';
import {EErrorActions, ErrorActions} from '@app/core/store/actions/error.actions';
import {EIntegrationsActions, IntegrationsActions} from '@app/core/store/actions/integrations.actions';

export const integrationsReducers = (
	state = initialIntegrationsState,
	action: IntegrationsActions | ErrorActions,
): IIntegrationsState => {
	switch (action.type) {
		case EErrorActions.LoadError: {
			return {
				...state,
				isLoading: false,
			};
		}
		case EIntegrationsActions.GetPaymentNumberModelsWithDepartments:
		case EIntegrationsActions.GetPaymentNumberModelsWithUsers:
		case EIntegrationsActions.ActivateIntegration:
		case EIntegrationsActions.RemoveIntegration:
		case EIntegrationsActions.PatchIntegration: {
			return {
				...state,
				isLoading: true,
			};
		}
		case EIntegrationsActions.ActivateIntegrationSuccess:
		case EIntegrationsActions.RemoveIntegrationSuccess:
		case EIntegrationsActions.PatchIntegrationSuccess: {
			return {
				...state,
				isLoading: false,
			};
		}
		case EIntegrationsActions.GetPaymentNumberModelsSuccess: {
			return {
				...state,
				isLoading: false,
				receivedTenant: action.tenant,
				paymentNumberModels: action.paymentNumberModels,
			};
		}
		default:
			return state;
	}
};
